// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ACTION_TO_ADD_ANSWER = "pridanie odpovede";
export const ACTION_TO_ADD_COMMENT = "pridanie odpovede";
export const ACTION_TO_TURN_NOTIFICATIONS_ON = "odoberanie upozornen\u00ed na nov\u00e9 odpovede";
export const ARE_YOU_SURE_YOU_WANT_TO_DELETE_COMMENT = "Naozaj chce\u0161 zmaza\u0165 koment\u00e1r?";
export const ARE_YOU_SURE_YOU_WANT_TO_DELETE_POST = "Naozaj chce\u0161 zmaza\u0165 pr\u00edspevok?";
export const ENTER_NEW_POSITION_OF_COMMENT = "Zadaj nov\u00fa poz\u00edciu odpovede";
export const EXPLAIN_COMMENT_DELETION = "Zadaj bli\u017e\u0161ie od\u00f4vodnenie:";
export const EXPLAIN_POST_DELETION = "Zadaj bli\u017e\u0161ie od\u00f4vodnenie:";
export const FORUM_POST_PINNED = "Pr\u00edspevok bol pripnut\u00fd. Bude sa zobrazova\u0165 vo f\u00f3re v\u017edy ako prv\u00fd.";
export const FORUM_POST_UNPINNED = "Zru\u0161ila si pripnutie pr\u00edspevku vo f\u00f3re.";
export const FORUM_TURNED_OFF_NOTIFICATIONS_FOR_NEW_ANSWERS = "Vypla si si upozornenia na nov\u00e9 odpovede k tejto diskusii.";
export const FORUM_TURNED_ON_NOTIFICATIONS_FOR_NEW_ANSWERS = "Zapla si si upozornenia na nov\u00e9 odpovede k tejto diskusii.";
